module.exports = ""


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/pages/gestao/gestao.component.css
 ** module id = 166
 ** module chunks = 0
 **/